<div class="dialog-close"><a class="close-button" href="javascript:;" (click)="handleClose()">x</a></div>